import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card card-xl-stretch mb-xl-3" }
const _hoisted_2 = { class: "card-title align-items-start flex-column" }
const _hoisted_3 = { class: "fw-bolder fs-3 mb-1" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-bold fs-7" }, "--------------", -1)
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "card-body pt-5" }
const _hoisted_7 = { class: "d-flex flex-center flex-column mb-5" }
const _hoisted_8 = { class: "symbol symbol-100px symbol-circle mb-7" }
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 1,
  src: "media/avatars/blank.png",
  alt: "image"
}
const _hoisted_11 = {
  href: "#",
  class: "fs-3 text-gray-800 text-hover-primary fw-bolder mb-1"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-1 svg-icon-primary" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M10.0813 3.7242C10.8849 2.16438 13.1151 2.16438 13.9187 3.7242V3.7242C14.4016 4.66147 15.4909 5.1127 16.4951 4.79139V4.79139C18.1663 4.25668 19.7433 5.83365 19.2086 7.50485V7.50485C18.8873 8.50905 19.3385 9.59842 20.2758 10.0813V10.0813C21.8356 10.8849 21.8356 13.1151 20.2758 13.9187V13.9187C19.3385 14.4016 18.8873 15.491 19.2086 16.4951V16.4951C19.7433 18.1663 18.1663 19.7433 16.4951 19.2086V19.2086C15.491 18.8873 14.4016 19.3385 13.9187 20.2758V20.2758C13.1151 21.8356 10.8849 21.8356 10.0813 20.2758V20.2758C9.59842 19.3385 8.50905 18.8873 7.50485 19.2086V19.2086C5.83365 19.7433 4.25668 18.1663 4.79139 16.4951V16.4951C5.1127 15.491 4.66147 14.4016 3.7242 13.9187V13.9187C2.16438 13.1151 2.16438 10.8849 3.7242 10.0813V10.0813C4.66147 9.59842 5.1127 8.50905 4.79139 7.50485V7.50485C4.25668 5.83365 5.83365 4.25668 7.50485 4.79139V4.79139C8.50905 5.1127 9.59842 4.66147 10.0813 3.7242V3.7242Z",
      fill: "#00A3FF"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      class: "permanent",
      d: "M14.8563 9.1903C15.0606 8.94984 15.3771 8.9385 15.6175 9.14289C15.858 9.34728 15.8229 9.66433 15.6185 9.9048L11.863 14.6558C11.6554 14.9001 11.2876 14.9258 11.048 14.7128L8.47656 12.4271C8.24068 12.2174 8.21944 11.8563 8.42911 11.6204C8.63877 11.3845 8.99996 11.3633 9.23583 11.5729L11.3706 13.4705L14.8563 9.1903Z",
      fill: "white"
    })
  ])
], -1)
const _hoisted_13 = {
  key: 0,
  class: "fs-5 fw-bold text-muted mb-6"
}
const _hoisted_14 = {
  key: 1,
  class: "fs-5 fw-bold text-muted mb-6"
}
const _hoisted_15 = { class: "d-flex flex-stack fs-4 py-3" }
const _hoisted_16 = {
  class: "fw-bolder rotate collapsible collapsed",
  "data-bs-toggle": "collapse",
  href: "#kt_customer_view_details",
  role: "button",
  "aria-expanded": "false",
  "aria-controls": "kt_customer_view_details"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "ms-2 rotate-180" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M11.4343 12.7344L7.25 8.55005C6.83579 8.13583 6.16421 8.13584 5.75 8.55005C5.33579 8.96426 5.33579 9.63583 5.75 10.05L11.2929 15.5929C11.6834 15.9835 12.3166 15.9835 12.7071 15.5929L18.25 10.05C18.6642 9.63584 18.6642 8.96426 18.25 8.55005C17.8358 8.13584 17.1642 8.13584 16.75 8.55005L12.5657 12.7344C12.2533 13.0468 11.7467 13.0468 11.4343 12.7344Z",
        fill: "black"
      })
    ])
  ])
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_19 = {
  id: "kt_customer_view_details",
  class: "collapse",
  style: {}
}
const _hoisted_20 = { class: "fs-6" }
const _hoisted_21 = { class: "fw-bolder mt-5" }
const _hoisted_22 = { class: "text-gray-600" }
const _hoisted_23 = { class: "fw-bolder mt-5" }
const _hoisted_24 = { class: "text-gray-600" }
const _hoisted_25 = { class: "fw-bolder mt-5" }
const _hoisted_26 = { class: "text-gray-600" }
const _hoisted_27 = { class: "fw-bolder mt-5" }
const _hoisted_28 = { class: "text-gray-600" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([`bg-${_ctx.widgetColor}`, "card-header border-0 py-5"])
    }, [
      _createElementVNode("h3", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.t("dashboard.mychild")), 1),
        _hoisted_4
      ]),
      _createElementVNode("img", {
        src: _ctx.building.logo,
        alt: "EdTrust",
        class: "h-50px w-50px rounded ml-5"
      }, null, 8, _hoisted_5)
    ], 2),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          (_ctx.store.getters.currentStudent.photo)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: 
              _ctx.store.getters.serverConfigUrl.base_url +
              '/' +
              _ctx.store.getters.currentStudent.photo
            ,
                alt: "image"
              }, null, 8, _hoisted_9))
            : (_openBlock(), _createElementBlock("img", _hoisted_10))
        ]),
        _createElementVNode("a", _hoisted_11, [
          _createTextVNode(_toDisplayString(_ctx.store.getters.currentStudent.firstName +
            " " +
            _ctx.store.getters.currentStudent.lastName), 1),
          _hoisted_12
        ]),
        (_ctx.store.getters.currentStudent.classRoom)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.store.getters.currentStudent.classRoom.name || "Non inscrit"), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_14, "\"Non inscrit\""))
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createTextVNode(_toDisplayString(_ctx.t("dashboard.details")) + " ", 1),
          _hoisted_17
        ])
      ]),
      _hoisted_18,
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.t("dashboard.building")), 1),
          _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.building.name), 1),
          _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t("dashboard.phoneNumber")), 1),
          _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.building.phone), 1),
          _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t("dashboard.adress")), 1),
          _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.building.adress), 1),
          _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.t("dashboard.headMaster")), 1),
          _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.building.headMaster), 1)
        ])
      ])
    ])
  ]))
}